import React from 'react';
import { Chip } from '@mui/material';

/**
 * Generate contrasting text color based on background color
 * @param {string} hexColor - Hex color code (e.g., '#c8e6c9')
 * @returns {string} - Contrast color ('#333333' or '#ffffff')
 */
const getContrastColor = (hexColor) => {
  if (!hexColor) return '#333333';
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#333333' : '#ffffff';
};

/**
 * DutyTypeBadge - displays duty type with dynamic color from API
 * @param {Object} dutyType - duty type object from API { id, code, name_vi, color }
 * @param {string} size - chip size ('small' or 'medium')
 */
const DutyTypeBadge = ({ dutyType, size = 'small' }) => {
  if (!dutyType) return null;

  const bgColor = dutyType.color || '#eeeeee';
  const textColor = getContrastColor(bgColor);

  return (
    <Chip
      label={dutyType.name_vi}
      size={size}
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: 500,
        fontSize: '0.75rem'
      }}
    />
  );
};

export default DutyTypeBadge;
